import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    createTheme,
    CssBaseline,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    Switch,
    TextField,
    ThemeProvider,
    Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getOneExpociencias22 } from "../../services/getOneExpociencias22";
import { LoadingDialog } from "../modules/dialogs/LoadingDialog";
import { useFetchFacturaCats } from "../../hooks/useFetchFacturaCats";
import { uploadFile } from "../../services/uploadFile";
import Swal from "sweetalert2";
import { sendEmail } from "../../services/sendEmail";
import moment from "moment";
import { updateDataExpociencias22 } from "../../services/updateDataExpociencias22";
import { setEmailBodyExpocienciasPagoMun } from "../../helpers/setEmailBodyExpocienciasPagoMun";
import { renderToString } from 'react-dom/server';
import { insertSolicitudFactura } from "../../services/insertSolicitudFactura";
import { SelectCustom } from "../modules/ui/SelectCustom";
import validator from 'validator';
import { CustomDialog } from "../modules/dialogs/CustomDialog";


export const ExpocienciasConfirma = () => {

    // Hook que obtiene los parametros que se envian por la Url, en este caso el id
    let params = useParams();
    const { id } = params;

    // state para los controles del formulario
    const [formValues, setFormValues] = useState({
        asesorNombres: "",
        asesorApellidos: "",
        asesorCorreo: "",
        asesorTelefono: "",
        asesorTallaCamiseta: "",
        instNombre: "",
        instDomicilio: "",
        instMunicipio: "",
        proyTitulo: "",
        proyCategoria: "",
        proyArea: "",
        proyResumen: "",
        participacion: "",
        est1NombreCompleto: "",
        est1Correo: "",
        est1Telefono: "",
        est1Edad: "",
        est1Sexo: "",
        est1TallaCamiseta: "",
        est2NombreCompleto: "",
        est2Correo: "",
        est2Telefono: "",
        est2Edad: "",
        est2Sexo: "",
        est2TallaCamiseta: "",
        est3NombreCompleto: "",
        est3Correo: "",
        est3Telefono: "",
        est3Edad: "",
        est3Sexo: "",
        est3TallaCamiseta: "",
        requiereFactura: false,
        factNombre: "",
        factRfc: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        comentarios: "",
        refBancaria: "",
        compPago: "",
        compPagoEst: "",
        claveProyRec: "",
        fechaRegistro: "",
        fechaPago: "",
        fechaPagoEst: "",
    });
    const {
        asesorNombres,
        asesorApellidos,
        asesorCorreo,
        asesorTelefono,
        asesorTallaCamiseta,
        instNombre,
        instDomicilio,
        instMunicipio,
        proyTitulo,
        proyCategoria,
        proyArea,
        proyResumen,
        participacion,
        est1NombreCompleto,
        est1Correo,
        est1Telefono,
        est1Edad,
        est1Sexo,
        est1TallaCamiseta,
        est2NombreCompleto,
        est2Correo,
        est2Telefono,
        est2Edad,
        est2Sexo,
        est2TallaCamiseta,
        est3NombreCompleto,
        est3Correo,
        est3Telefono,
        est3Edad,
        est3Sexo,
        est3TallaCamiseta,
        requiereFactura,
        factNombre,
        factRfc,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        comentarios,
        refBancaria,
        compPago,
        compPagoEst,
        claveProyRec,
        fechaRegistro,
        fechaPago,
        fechaPagoEst,
    } = formValues;

    // state para la forma de pago
    const [detalles, setDetalles] = useState({
        formaPago: "",
        importe: "",
    });
    const { importe, formaPago } = detalles;
    const handleDetallesChange = ({ target }) => {
        console.log(target.name, target.value);
        setDetalles({
            ...detalles,
            [target.name]: target.value,
        });
    };

    // state para el fileupload
    const [file, setFile] = useState({
        file: '',
    });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // Para el swich de "Requiere Factura"
    const [checked, setChecked] = useState(false);
    const switchHandler = (event) => {
        setChecked(event.target.checked);

        setFormValues({
            ...formValues,
            [event.target.name]: event.target.checked,
        });
    };

    // state para indicar si el formulario esta enviandose o no
    const [sendingForm, setSendingForm] = useState(false);
    // Waiting Dialog
    const handleCloseSendingForm = (_, reason) => {
        if (reason !== 'backdropClick') {
            setSendingForm(false);
        }
    };

    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };

    // Validar el formumario
    const isFormValid = () => {

        // No ha indicado ningun archivo
        if ( file.file === '' ) {
            Swal.fire("Agregar documento.", `Por favor selecciona un archivo como comprobante.`, "error");
            return false;
        }

        // Indico archivo pero no es un PDF
        const fullName = file.file.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
        if ( file.file !== '' && fileExt !== 'PDF' ) {
            Swal.fire("Documento incorrecto.", `El comprobante debe ser un archivo PDF.`, "error");
            return false;
        }

        // No ha indicado ninguna forma de pago
        if ( formaPago === '' ) {
            Swal.fire("Indicar la forma de pago.", `Los campos marcados con [ * ] son obligatorios.`, "error");
            return false;
        }

        // Importe obligatorio
        if ( importe <= 0 ) {
            Swal.fire("Indicar importe.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        // Campos obligatorios en caso de que requiera factura
        if (requiereFactura) {

            if ( [ factNombre, factRfc, factCP, factUsoCFDI, factRegimenFiscal ].includes("") ) {
            Swal.fire("Datos para facturar incompletos.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
            }
            
            if (!validator.isAlphanumeric(factRfc)) {
                Swal.fire("Verificar los datos para facturar", "El RFC contiene caracteres inválidos.", "error");
                return false;
            } 
            
        }

        return true;
    }

    // Procesar la info
    const isDataProcessed = async() => {

        // - actualizar en db
        const saveResult = await updateDataExpociencias22(formValues);
        // console.log(saveResult);
        if (saveResult.exito === 0) {
            return false;
        }

        // - subir archivo en PDF
        const fileName = `${refBancaria}_pagoMun.pdf`
        const resultUpload = await uploadFile({file, fileName});
        // console.log(resultUpload);
        if (resultUpload.exito === 0) {
            return false;
        }

        // - enviar correo
        const urlPagoMunicipal = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/${resultUpload.data}`;
        const msgbody = renderToString( setEmailBodyExpocienciasPagoMun(formValues, urlPagoMunicipal) );
        const emailResult = await sendEmail({
            "toemail": asesorCorreo,
            "subject": "[Expociencias 2022] Comprobante municipal",
            "message": msgbody,
            "replyto": "expociencias@cibnor.mx",
            "tocc": process.env.REACT_APP_TOCC_EXPOCIENCIAS22,
            "tobcc": process.env.REACT_APP_TOBCC_EXPOCIENCIAS22,
        });
        // console.log(emailResult);
        if (emailResult.exito === 0) {
            return false;
        }

        // - ingresar la solicitud de factura
        if (formValues.requiereFactura) {

            const values = {
                fecha: formValues.fechaPago,
                nombreCliente: formValues.factNombre,
                rfcCliente: formValues.factRfc,
                codigoPostal: formValues.factCP,
                telefonoCliente: formValues.asesorTelefono,
                correoElectronico: formValues.asesorCorreo,
                correoEvento: "expociencias@cibnor.mx",
                regimenFiscalID: formValues.factRegimenFiscal,
                proyecto: formValues.claveProyRec,
                usoCFDI: formValues.factUsoCFDI,
                envioSolicitud: "eventos",
                solicitanteID: 494,
                ejercicio: moment().format("YYYY"),
                quienRegistro: 494,
                importe: importe,
                formaPago: detalles.formaPago,
                NumeroRegistro: formValues.refBancaria,
                archivoPDF: urlPagoMunicipal,
            };
            // console.log(values);
            const insertResult = await insertSolicitudFactura(values);
            console.log(insertResult);
        }

        return true;
    }

    // Submit form | Boton ENVIAR 
    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log("Enviar formulario...");
        
        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) {
            return false;
        }

        // Se muestra el dialogo de enviando formulario
        setSendingForm(true);

        // Procesa la info
        const AllOk = await isDataProcessed();
        setSendingForm(false);
        if ( AllOk ) {
            let timerInterval
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sus datos han sido recibidos exitosamente.",
                text: 'Consulte su correo electrónico para más información.',
                icon: 'success',
                html: 'Redireccionado a la pagina del evento en <b></b> segundos.',
                timer: 20000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                        b.textContent = Math.round( Swal.getTimerLeft()/1000 )
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }
            }).then((result) => {
                if (result.dismiss === Swal.DismissReason.timer) {
                    // 
                    // Redireccionar a otra pagina
                    // 
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 
 
        } else {
            await sendEmail({
                "toemail": "eventos@cibnor.mx",
                "subject": "[Expociencias 2022] Error",
                "message": formValues,
            });

            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor...",
                text: 'Disculpe el inconveniente.',
                icon: 'error',
                confirmButtonText: 'Ir al sitio web del evento',
                footer: 'Ya se ha notificado al area correspondiente sobre su situación.'
            }).then((result) => {
                if (result.isConfirmed) { 
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/3180-expociencias-2022');
                }
            }); 
        }

        console.log(
            asesorNombres,
            asesorApellidos,
            asesorCorreo,
            asesorTelefono,
            asesorTallaCamiseta,
            instNombre,
            instDomicilio,
            instMunicipio,
            proyTitulo,
            proyCategoria,
            proyArea,
            proyResumen,
            participacion,
            est1NombreCompleto,
            est1Correo,
            est1Telefono,
            est1Edad,
            est1Sexo,
            est1TallaCamiseta,
            est2NombreCompleto,
            est2Correo,
            est2Telefono,
            est2Edad,
            est2Sexo,
            est2TallaCamiseta,
            est3NombreCompleto,
            est3Correo,
            est3Telefono,
            est3Edad,
            est3Sexo,
            est3TallaCamiseta,
            requiereFactura,
            factNombre,
            factRfc,
            factCP,
            factUsoCFDI,
            factRegimenFiscal,
            comentarios,
            refBancaria,
            compPago,
            compPagoEst,
            claveProyRec,
            fechaRegistro,
            fechaPago,
            fechaPagoEst
        );
    };
    
    // Se ejecuta al cargarse la pagina y de acuerdo al _loading_ se muestra/oculta el dialog de "Cargando inf..."
    const { dataCDFIs, dataRFs, loading } = useFetchFacturaCats();

    // Se ejecuta una sola vez al cargar la pagina
    useEffect(() => {
/**
 * Para ejecutar una funcion (isUserDataLoaded) despues de la carga inicial de la pagina 
 * es necesario condicionar su ejecucion "(if (dataCDFIs.length !== 0) {)" si ya se modifico 
 * uno de los elementos (dataCDFIs) que obtienen su valor al cargarse la pagina. Asi mismo,
 * esta funcion se debe definir dentro del useEffect y, en la dependencia de este,
 * se indican los elementos que obtienen sus valores al cargarse la pagina (dataCDFIs, id).
 */
        const isUserDataLoaded = async () => {

            if (dataCDFIs.length !== 0) {
    
                const resultDataLoaded = await getOneExpociencias22(id);
                
                if (resultDataLoaded.exito === 1) {
                    const dataLoaded = resultDataLoaded.data;
                    // console.log(dataLoaded.fechaPago);

                    // El comprobante "ya fue subido"
                    if (dataLoaded.fechaPago !== null) {
                        Swal.fire({
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            title: "Ya existe el comprobante.",
                            text: `El documento fue subido el ${ moment(dataLoaded.fechaPago).format("DD/MMM") } al sistema.`,
                            footer: "Gracias por su interes en nuestro evento.",
                            showConfirmButton: false,
                            icon: 'success',
                        });
                    }

                    // Establecemos los valores nuevos (fechaPago)
                    const dateNow = moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss');
                    dataLoaded.fechaPago = dateNow;

                    if (dataLoaded.requiereFactura === "true") {
                        dataLoaded.requiereFactura = true;
                        setChecked(true);
                    } else {
                        dataLoaded.requiereFactura = false;
                        setChecked(false);
                    }

                    setFormValues({
                        ...dataLoaded,
                    });
                }
        
                return true;
            };
        }

        isUserDataLoaded();
    }, [dataCDFIs, id]);



    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Avatar
                        sx={{ width: 270, height: 207 }}
                        src="https://eventos.cibnor.mx/registro/expociencias/img/logo_expociencias2022.png"
                        variant="square"
                    />
                    <Typography variant="h5">Confirmación de registro</Typography>
                    {/* Inicio del formulario */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                        autoComplete="off"
                    >

                        {/* Contenedor general */}
                        <Grid container maxWidth={window.innerWidth} spacing={2} sx={{ pt: 2, pb: 3 }}>
                            <Grid item xs={12}>
                            <Paper elevation={2}>
                                <Card variant="outlined">
                                <CardContent>
                                    <Grid container spacing={1}>
                                        <Grid item xs={2}>
                                            <Typography variant="h6" align="center" sx={{ p: 0 }}>Hola, </Typography>
                                        </Grid>
                                        <Grid item xs={10} >
                                            <TextField
                                                id="asesorNombres"
                                                fullWidth
                                                value={ asesorNombres + " " + asesorApellidos }
                                                helperText={ "<" + asesorCorreo+ ">"}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                variant="standard"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" align="center" sx={{ p: 2 }}>Por favor agregue su comprobante de pago y confirme o actualice los datos de facturación.</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                type={"file"}
                                                fullWidth
                                                variant="standard"
                                                onChange={e => setFileState(e)}
                                                helperText="Archivo en formato PDF *"
                                                
                                            />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <SelectCustom 
                                            parentCallback={handleDetallesChange}
                                            name={"formaPago"}
                                            label={"Forma de pago"}
                                            variant={"outlined"}
                                            options={[
                                                {value:'01', label:'Efectivo'},
                                                {value:'02', label:'Cheque nominativo'},
                                                {value:'03', label:'Transferencia'},
                                                {value:'04', label:'Tarjeta de crédito'},
                                                {value:'05', label:'Monedero electrónico'},
                                            ]}
                                            required
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField 
                                                type={"number"}
                                                fullWidth
                                                inputProps={{ style: { textAlign: 'right' }}}
                                                label="Importe *"
                                                id="importe"
                                                name="importe"
                                                size="small"
                                                value={importe}
                                                onChange={handleDetallesChange}
                                            />
                                        </Grid>
                                    
                                        {/* Requiere factura */}
                                        <Grid item xs={12} sx={{ pt: 1, pb: 1 }}>
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                alignItems="center"
                                            >
                                                <Switch
                                                    inputProps={{ "aria-label": "ant design" }}
                                                    id={"requiereFactura"}
                                                    name={"requiereFactura"}
                                                    onChange={switchHandler}
                                                    checked={checked}
                                                />
                                                <Typography>Requiere factura</Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                id="factNombre"
                                                label="Nombre completo"
                                                name="factNombre"
                                                onChange={handleInputChange}
                                                required
                                                size="small"
                                                value={factNombre}
                                            />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                fullWidth
                                                id="factRfc"
                                                label="RFC"
                                                name="factRfc"
                                                onChange={handleInputChange}
                                                required
                                                size="small"
                                                value={factRfc}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                fullWidth
                                                id="factCP"
                                                label="C.P."
                                                name="factCP"
                                                onChange={handleInputChange}
                                                required
                                                size="small"
                                                type="number"
                                                value={factCP}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth required size="small">
                                                <InputLabel id="select-usocfdi">
                                                    Uso CFDI
                                                </InputLabel>
                                                <Select
                                                    value={factUsoCFDI}
                                                    id="factUsoCFDI"
                                                    label="Uso CFDI"
                                                    name="factUsoCFDI"
                                                    onChange={handleInputChange}
                                                >
                                                    {dataCDFIs.map(({ value, label }) => (
                                                        <MenuItem value={value} key={value}>
                                                            {label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth size="small" required>
                                                <InputLabel id="select-regimenfiscal">
                                                    Regimen fiscal
                                                </InputLabel>
                                                <Select
                                                    defaultValue={""}
                                                    value={factRegimenFiscal}
                                                    id="factRegimenFiscal"
                                                    label="Regimen fiscal"
                                                    name="factRegimenFiscal"
                                                    onChange={handleInputChange}
                                                >
                                                    {dataRFs.map(({ value, label }) => (
                                                        <MenuItem value={value} key={value}>
                                                            {label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                </CardContent>
                                </Card>
                            </Paper>
                            </Grid>
                        </Grid>
                        
                        {/* Boton */}
                        <Paper elevation={2}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="outlined"
                                endIcon={<SendIcon />}
                            >
                                Enviar
                            </Button>
                        </Paper>
                    </Box>
                    {/* Footer */}
                    <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                        <Grid item xs={12}>
                            <Divider />
                            <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                                <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                                Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                                La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                                <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                            </Typography >
                        </Grid>
                    </Grid>
                    {/* Dialog de carga del inicio */}
                    { loading ? <LoadingDialog /> : '' }
                </Box>
                {/* Dialogo de espera porque se esta enviando la informacion */}
                <Dialog 
                    open={sendingForm}
                    onClose={handleCloseSendingForm}
                    disableEscapeKeyDown={true}
                    >
                    <DialogTitle id="alert-dialog-title" >
                        {"Por favor, espere..."}
                    </DialogTitle>
                    <DialogContent sx={{
                                    margin: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                {/* Dialogo de registro cerrado */}
                <CustomDialog 
                    show={true} 
                    title={'Gracias por su interes...'} 
                    content={'Este evento actualmente se encuentra cerrado.'} 
                />
            </Container>
        </ThemeProvider>
    );
};
